// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"197":"b828a696","622":"35ff1673","725":"b14efd18"}[chunkId] + ".chunk.js";
};